export const state = {
    loader: false,
    jobApplicants:[],
    jobApplicant: null,
  }
  